module.exports = __webpack_public_path__ + "static/media/1022350.ecb30b23.jpg";